export class Guid
{
    public static guidExpression = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    private value = "";

    private constructor()
    {
    }

    public static new(): Guid
    {
        const guid = new Guid();
        guid.generate();
        return guid;
    }

    private static _empty: Guid | null = null;
    public static get empty(): Guid
    {
        if (Guid._empty == null)
        {
            Guid._empty = new Guid();
            Guid._empty.value = "00000000-0000-0000-0000-000000000000";
        }
        return Guid._empty;
    }

    public static isValid(value: string): boolean
    {
        const isValid = Guid.guidExpression.test(value);
        return isValid;
    }

    public static parse(value: string): Guid | null
    {
        if (!Guid.isValid(value))
        {
            return null;
        }

        const guid = new Guid();
        guid.value = value.toUpperCase();
        return guid;
    }

    public static insertGuidDashes(value: string): string
    {
        // Remove existing dashes
        const noDashes = value.replace(/-/g, '');

        const parts = [
            noDashes.slice(0, 8),
            noDashes.slice(8, 12),
            noDashes.slice(12, 16),
            noDashes.slice(16, 20),
            noDashes.slice(20, 32),
        ];

        const withDashes = parts.filter(part => part.length > 0).join('-');
        return withDashes;
    }

    private generate(): void
    {
        this.value = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, char => (Math.random() * 16 | 0).toString(16)).toUpperCase();
    }

    public toString(format = "D"): string
    {
        switch (format)
        {
            case "D":
                return this.value;
            case "N":
                return this.value.replace(/-/g, "");
            default:
                throw new Error(`"The format '${format}' is not supported`);
        }
    }
}